export default __webpack_public_path__ + "static/cafe_36028-cb1468782833db73164e65be6bbe9762.png";